import { topbarTokens } from '../Topbar/tokens';
import { TEXT_COLOR, BRAND_TURQUOISE } from '../../theme';

export const resultsTokens = {
    ...topbarTokens,
    color: {
        ...topbarTokens.color,
        success: '#10B981',
        successSoft: '#ECFDF5',
        warning: '#F59E0B',
        warningSoft: '#FFF7E6',
        danger: '#EF4444',
        dangerSoft: '#FEF2F2',
        chipBg: '#F3F4F6',
        chipFg: TEXT_COLOR,
        // High-potential turquoise, shared from the brand palette so the dashboard
        // dots and this table's star stay in sync from a single source (theme.js).
        starOk: BRAND_TURQUOISE,
    },
};
